export default "__VITE_ASSET__CgWhPmFI__"